var $31255cd1da2c08d2$exports = {};
$31255cd1da2c08d2$exports = {
    "actions": `Handlinger`,
    "actionsAvailable": `Tilgjengelige handlinger.`,
    "clearSelection": `T\xf8m utvalg`,
    "selected": (args)=>`Valde element: ${args.count}`,
    "selectedAll": `Alle er valgt`
};


export {$31255cd1da2c08d2$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
